// Single source of truth for brand contact details.
export const BRAND = {
  name: "Urban Painter",
  domain: "urbanpainter.in",
  tagline: "Epoxy Flooring · Waterproofing · Painting",
  established: 2019,
  phone: "+91 95999 20839",
  phone_tel: "+919599920839",
  whatsapp: "+919599920839",
  whatsapp_message:
    "Hello Urban Painter, I am interested in your Epoxy Flooring / Waterproofing / Painting services. I would like to discuss my project and request a site inspection and quotation.",
  email: "info@urbanpinter.in",
  city: "Gurugram, Haryana",
  address:
    "Plot No. 5, Near Sonu Dharam Kanta, Kherki Daula, Sihi, Gurugram, Haryana",
  hours: "Mon – Sat · 9:00 AM – 7:00 PM",
  service_area: [
    "Gurugram",
    "Gurgaon",
    "Manesar",
    "Sohna",
    "New Gurgaon",
    "Golf Course Road",
    "DLF Phase I – V",
    "South Delhi",
    "Delhi NCR",
    "Haryana",
  ],
  mapEmbed:
    "https://www.google.com/maps?q=Plot+No.+5+Sonu+Dharam+Kanta+Kherki+Daula+Sihi+Gurugram+Haryana&output=embed",
  social: {
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
    youtube: "https://youtube.com/",
  },
};

export function waLink(message = BRAND.whatsapp_message) {
  const num = BRAND.whatsapp.replace(/[^0-9]/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
}

export function telLink() {
  return `tel:${BRAND.phone_tel}`;
}
